export default "__VITE_ASSET__BbjR55bo__"